export default {
  reviewCompleteHeader: 'ตรวจสอบและดำเนินการ',
  participants: 'ผู้เข้าร่วม',
  enterParticipantInfoText: 'กรุณากรอกข้อมูลที่จำเป็นเพื่อดำเนินการชำระเงิน',
  purchaser: 'ผู้ซื้อ',
  firstName: 'ชื่อ',
  lastName: 'นามสกุล',
  email: 'อีเมล',
  optionalEmail: 'อีเมล: (ไม่บังคับ)',
  'phone:': 'โทรศัพท์',
  participantFieldPlaceholder: 'เพิ่มใหม่หรือเลือกผู้เข้าร่วมที่มีอยู่',
  reservationSummary: 'สรุปการจอง',
  editParticipantsDetails: 'แก้ไขรายละเอียดผู้เข้าร่วม',
  participantDetails: 'รายละเอียด',
  duplicatePurchaserText: 'เหมือนกับผู้ซื้อ',
  phone: 'โทรศัพท์',
  addParticipant: '{{tierLabel}} เพิ่มเติม',
  participant: 'ผู้เข้าร่วม',
  removeParticipant: 'ลบ',
  experienceCheckoutCompleted: 'การชำระเงินประสบการณ์เสร็จสมบูรณ์',
  experienceCartCheckout: 'ชำระเงินตะกร้าประสบการณ์',
  experienceLimitReached: 'ขออภัย ประสบการณ์นี้ถึงจำนวนผู้เข้าร่วมสูงสุดแล้ว',
  payment: 'การชำระเงิน',
  duration: 'ระยะเวลา',
  discountCode: 'รหัสส่วนลด',
  removeCode: 'ลบรหัส',
  invalidCodeValidation: 'รหัสคูปองไม่ถูกต้อง',
  networkErrorDiscountCode: 'เกิดข้อผิดพลาดจากระบบของเรา',
  onlyOneCouponCodeAllowed: 'อนุญาตให้ใช้รหัสคูปองได้เพียงหนึ่งรหัสเท่านั้น',
  creditCodeHasAlreadyBeenApplied: 'รหัสเครดิตถูกใช้ไปแล้ว',
  discount: 'ส่วนลด',
  promo: 'โปรโม',
  promoCode: 'รหัสโปรโมชัน',
  apply: 'ใช้',
  total: 'รวม',
  subTotal: 'ยอมรวมย่อย',
  includes: 'รวม',
  and: 'และ',
  addHostNotes: 'เพิ่มบันทึกสำหรับผู้จัดกิจกรรมของคุณ',
  brandAggreementText:
    'ข้าพเจ้ายอมรับ หรือข้าพเจ้ารับรองว่าข้าพเจ้าได้รับอนุญาตในนามของผู้เข้าร่วมเพื่อยอมรับข้อกำหนดและเงื่อนไขของ',
  termsAggreementValidation: 'กรุณายอมรับข้อกำหนด',
  firstNameValidation: 'จำเป็นต้องกรอกชื่อ',
  lastNameValidation: 'จำเป็นต้องกรอกนามสกุล',
  emailValidation: {
    emailRequiredText: 'จำเป็นต้องกรอกอีเมล',
    invalidEmail: 'ที่อยู่อีเมลไม่ถูกต้อง',
    not_specified: 'ที่อยู่อีเมลไม่ถูกต้อง',
  },
  phoneValidation: {
    'Invalid Phone Number': 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
    not_specified: 'ไม่ถูกต้อง',
    phoneRequiredText: 'จำเป็นต้องกรอกหมายเลขโทรศัพท์',
  },
  participantFirstNameValidation: 'จำเป็นต้องกรอกชื่อผู้เข้าร่วม',
  participantLastNameValidation: 'จำเป็นต้องกรอกนามสกุลผู้เข้าร่วม',
  complete: 'เสร็จสิ้น',
  '404Message': 'ไม่พบหน้าที่ต้องการ',
  waiting: 'กำลังรอ...',
  complimentary: 'ฟรี',
  confirmationHeader: 'ประสบการณ์ของคุณได้รับการจองแล้ว!',
  confirmationText:
    'อีเมลยืนยันได้ถูกส่งไปยัง {{email}} พร้อมรายละเอียดเพิ่มเติม',
  viewAll: 'ดูประสบการณ์ทั้งหมด',
  paymentMethod: 'วิธีการชำระเงิน',
  creditCard: 'บัตรเครดิต',
  roomCharge: 'เรียกเก็บจากห้องพัก',
  memberCharge: 'เรียกเก็บจากสมาชิก',
  roomOrReservationNumber: 'หมายเลขห้องหรือหมายเลขยืนยัน',
  roomNumber: 'หมายเลขห้อง',
  roomNumberLegacy: 'หมายเลขห้อง / รหัสยืนยัน',
  memberNumber: 'หมายเลขสมาชิก',
  kicc: 'KICC',
  chargeValidation: 'จำเป็นต้องกรอกหมายเลขห้องและนามสกุล',
  memberNumberValidation: 'จำเป็นต้องกรอกหมายเลขสมาชิก',
  invalidRoomNumber: 'หมายเลขห้องไม่ถูกต้อง',
  invalidRoomNumberLegacy: 'หมายเลขห้องหรือรหัสยืนยันไม่ถูกต้อง',
  invalidMemberNumber: 'หมายเลขสมาชิกไม่ถูกต้อง',
  invalidPhoneNumber: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
  requiredPhoneNumber: 'จำเป็นต้องกรอกหมายเลขโทรศัพท์',
  guestNameIsRequired: 'จำเป็นต้องกรอกชื่อผู้เข้าพัก',
  roomNumberIsRequired: 'จำเป็นต้องกรอกหมายเลขห้อง',
  roomNumberIsRequiredLegacy: 'จำเป็นต้องกรอกหมายเลขห้องหรือรหัสยืนยัน',
  roomOrReservationNumberIsRequired:
    'จำเป็นต้องกรอกหมายเลขห้องหรือหมายเลขยืนยัน',
  cardNumberIncomplete: 'หมายเลขบัตรไม่สมบูรณ์',
  lastNameValidationError: 'จำเป็นต้องกรอกนามสกุล',
  isReqd: 'จำเป็นต้องกรอก',
  reservationCode: 'หมายเลขการจอง/ยืนยัน',
  nonHotelGuest: 'ผู้เข้าพักที่ไม่ได้พักในโรงแรม',
  onPropertyGuest: 'ผู้เข้าพักในโรงแรม',
  preArrivalGuest: 'ผู้เข้าพักก่อนเช็คอิน',
  cardNumber: 'หมายเลขบัตร',
  pmsValidationErrorMessage:
    'นามสกุลหรือหมายเลขห้องหรือหมายเลขยืนยันไม่ถูกต้อง',
  pmsDateValidationErrorMessage:
    'ขออภัย! วันที่ของประสบการณ์ไม่อยู่ระหว่างวันที่เข้าพักและวันที่ออก',
  fullName: 'ชื่อ-นามสกุล',
  checkout: 'ชำระเงิน',
  editParticipants: 'แก้ไขผู้เข้าร่วม',
  private: 'ส่วนตัว',
  browseAllExperieces: 'เรียกดูประสบการณ์ทั้งหมด',
  payWithCreditCard: 'ชำระด้วยบัตรเครดิต',
  payWithRoomCharge: 'เรียกเก็บจากห้องพัก',
  payWithMemberCharge: 'เรียกเก็บจากสมาชิก',
  payWith: 'ชำระด้วย',
  bookBulkErrorByCard:
    'เกิดปัญหาในการยืนยันการจอง บัตรของคุณไม่ถูกเรียกเก็บเงิน',
  bookBulkErrorByRoomCharge: 'นามสกุลและหมายเลขห้องไม่ถูกต้อง',
  bookBulkErrorByMemberCharge: 'นามสกุลและหมายเลขสมาชิกไม่ถูกต้อง',
  reviewCancellation: 'ตรวจสอบการยกเลิก',
  selectAReservationToCancel: 'เลือกการจองที่ต้องการยกเลิก',
  confirmCancellation: 'ยืนยันการยกเลิก',
  cancellable: 'สามารถยกเลิกได้',
  cancelled: 'ยกเลิกแล้ว',
  deadlinePassed: 'เลยกำหนดเวลาแล้ว',
  noCancellations: 'ไม่มีการยกเลิก',
  reviewReschedule: 'การจองของคุณ',
  selectAReservationToReschedule: 'เลือกการจองที่ต้องการเลื่อน',
  confirmReservation: 'ยืนยันการจอง',
  confirm: 'ยืนยัน',
  selectADateAndTime: 'เลือกวันที่และเวลา',
  noOtherSessionsAvailableForThisExperience:
    'ไม่มีรอบอื่นที่ว่างสำหรับประสบการณ์นี้',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'การจองนี้ไม่สามารถเลื่อนได้อีกต่อไป กรุณาส่งอีเมลไปที่ {{brandEmail}}',
  thisReservationCannotBeRescheduled: 'การจองนี้ไม่สามารถเลื่อนได้',
  noTimesAvailable: 'ไม่มีเวลาที่ว่าง',
  noBookingsAvailable: 'ไม่มีการจองที่ว่าง',
  youPaid: 'คุณชำระแล้ว',
  refund: 'คืนเงิน',
  yourRefund: 'เงินคืนของคุณ',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'เงินคืนของคุณจะถูกดำเนินการไปยังการชำระเงินเดิม',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'การจองนี้ไม่สามารถยกเลิกได้อีกต่อไป กรุณาส่งอีเมลไปที่ {{brandEmail}}',
  reservationCancelled: 'การจองถูกยกเลิกแล้ว',
  thisReservationCannotBeCancelled: 'การจองนี้ไม่สามารถยกเลิกได้',
  thisReservationHasAlreadyBeenCancelled: 'การจองนี้ถูกยกเลิกไปแล้ว',
  theHotel: 'โรงแรม',
  cancelling: 'กำลังยกเลิก',
  somethingWentWrong: 'เกิดข้อผิดพลาด',
  previouslyRefunded: 'คืนเงินก่อนหน้านี้แล้ว',
  remainingBalance: 'ยอมคงเหลือ',
  notEnoughPoints: 'คะแนนไม่เพียงพอ',
  notEnoughPointsDescription:
    'คุณมีคะแนน World of Hyatt ไม่เพียงพอสำหรับการซื้อนี้',
  currentPointsBalance: 'ยอมคะแนนคงเหลือ: {{count, number}}',
  points: 'คะแนน',
  pointsWithCount_one: '{{count, number}} คะแนน',
  pointsWithCount_other: '{{count, number}} คะแนน',
  payWithHyattPoints: 'ชำระด้วยคะแนน Hyatt',
  pleaseSignIn: 'กรุณาเข้าสู่ระบบ',
  worldOfHyattPoints: 'คะแนน World of Hyatt',
  bookBulkErrorByNotEnoughSeats:
    'ที่นั่งไม่เพียงพอสำหรับรอบนี้ กรุณาลองรอบอื่นแทน',
  phoneNumber: 'หมายเลขโทรศัพท์',
  requestToBookConfirmationText: 'อีเมลยืนยันได้ถูกส่งไปยัง {{email}}',
  reservationRescheduled: 'การจองถูกเลื่อนแล้ว',
  yourReservationWasRescheduledTo: 'การจองของคุณถูกเลื่อนไปเป็น',
  viewExperiences: 'ดูประสบการณ์',
  joinBook: 'สมัคร & จอง',
  signInBook: 'เข้าสู่ระบบ & จอง',
  signAndJoin: 'เข้าสู่ระบบหรือสมัครเพื่อจอง',
  signAndJoinDescription:
    'ประสบการณ์ World of Hyatt FIND เป็นสิทธิพิเศษสำหรับสมาชิก World of Hyatt เข้าสู่ระบบหรือสมัครเพื่อจองและสะสมคะแนน ไม่ต้องการสมัคร? คุณยังสามารถจองประสบการณ์ที่ไม่ใช่สิทธิพิเศษได้โดยลบประสบการณ์ World of Hyatt ออกจากตะกร้า',
  promoOrFind: 'รหัสโปรโมหรือรหัสเครดิต Find',
  hyattTermsAndConditions: 'ข้อกำหนดและเงื่อนไข',
  hyattTermsAndConditionsAgreement:
    'โดยการยืนยันการจองนี้ ข้าพเจ้ายอมรับนโยบายการยกเลิก ข้าพเจ้าได้อ่านและรับทราบการใช้ข้อมูลส่วนบุคคลของข้าพเจ้าตาม',
  hyattTermsAndConditionsLink: 'นโยบายความเป็นส่วนตัวของ Hyatt',
  hyattWaiverText:
    'โดยการซื้อประสบการณ์นี้ ข้าพเจ้ายอมรับ เข้าใจ และรับทราบ ทั้งในนามของตนเองและในนามของบุคคลใดก็ตามที่เข้าร่วมในประสบการณ์ที่ข้าพเจ้าซื้อ (ถ้ามี) ต่อสิ่งต่อไปนี้',
  hyattWaiverLink: 'การสละสิทธิ์ทั่วไป',
  priceDisclaimer: 'รวมค่าธรรมเนียมก่อนภาษี',
  curatedRecommendations: 'คำแนะนำที่คัดสรร',
  moreExperiencesYouMightLike: 'ประสบการณ์อื่นที่คุณอาจชอบ',
  similarExperiencesAvailableToBookDirectly:
    'ประสบการณ์คล้ายกันที่สามารถจองได้โดยตรง',
  experiencesAvailableAroundYourBookingDate:
    'ประสบการณ์ที่มีรอบวันที่ใกล้เคียงกับการจองของคุณ',
  confirmationEmailSent:
    'เราได้ส่งการยืนยันไปยัง {{email}} พร้อมรายละเอียดเพิ่มเติม',
  youreBooked: 'จองสำเร็จแล้ว',
  purchaserInformation: 'ข้อมูลผู้ซื้อ',
  requiredFieldIndicator: '* หมายถึงฟิลด์ที่จำเป็นต้องกรอก',
  resourceSelectionTitle: 'เลือกตัวเลือกของคุณ',
  resourceSelectionDescription: 'เลือกตัวเลือกสำหรับแต่ละรายการในการจองของคุณ',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'เลือก{{attributeName}}',
  resourceValueSoldOut: '{{label}} (ขายหมดแล้ว)',
  resourceValueUnavailableWith: '{{label}} (ไม่มีให้เลือกกับ {{picks}})',
  resourceOptionsUnavailable:
    'ไม่สามารถโหลดตัวเลือกสำหรับเวลานี้ได้ โปรดลองอีกครั้ง',
  resourceOptionsRetry: 'ลองอีกครั้ง',
  changeResourceSelections: 'เปลี่ยนตัวเลือกของคุณ',
};
